import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Menu } from '../menu/menu';
import { Topbar } from '../topbar/topbar';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule, Menu, Topbar],
  templateUrl: './header.html',
  styleUrl: './header.css',
})
export class Header {
  constructor(private translate: TranslateService) {}
}
